require('./dropdownInterveners.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

class IntervenerItemSelected extends React.Component {
    render () {
        const { value } = this.props;
        const intervener = value
        const id = `${intervener.id}_Selected`;

        return (
            <div id={id} className="Select-value dropdown-interveners__intervener">
                <div className="Select-value-label row no-outside-gutter">
                    <div className="dropdown-interveners__intervener-description-center">
                        <span className="dropdown-interveners__intervener-description-name col-xs-9">{intervener.name}</span>
                        <span className="dropdown-interveners__intervener-description-intervention-type col-xs-3">{intervener.interventionType}</span>
                    </div>
                </div>
            </div>
        );
    }
}

IntervenerItemSelected.propTypes = {
    value: PropTypes.object
};

module.exports = IntervenerItemSelected;
